import Model from '@ember-data/model';

/**
 * Common base model
 */
export default class ShModel extends Model {

}
